import { useMutation } from '@apollo/react-hooks';
import { ConsoleLogger, LoggerService } from 'logger-extension-vfs';
import React, { useEffect, useState } from 'react';
import { VERIFY_EMAIL } from './mutation';
import { LogoSpinnerV } from 'react-logo-spinner-ext';
import {useHistory, useLocation, Prompt} from 'react-router-dom';
// import {Verifier} from '../LandingPage/components/VerifierPage';
import {VerificationSuccess} from './components/VerificationSuccess';
import { VerificationFailure } from './components/VerificationFailure';

const console: LoggerService = new LoggerService(
  new ConsoleLogger('VerifyUser:container'),
);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const VerifyUser = () => {
  const [VerifyEmail, { data, loading, error, called }] = useMutation(VERIFY_EMAIL);
  const history = useHistory();
  const query = useQuery(); 
  
  useEffect(() => {
    if (query.get('email') && query.get('token')) {
      VerifyEmail({
        variables: {
          credential: {
            email: query.get('email'),
            token: query.get('token'),
          },
        },
      });
      var uri = window.location.toString();
      if (uri.indexOf('?') > 0) {
        var clean_uri = uri.substring(0, uri.indexOf('?'));
        window.history.replaceState({}, document.title, clean_uri);
      }
    }
  }, []);

const _renderBody = () => {
  if(loading){
    return <LogoSpinnerV uri={'https://i.ibb.co/bWBCqc6/we-do-verify-icon.png'} />
  }
  if(data){
    return <VerificationSuccess />
  }
  if(error){
    return <VerificationFailure />
  }
  else {
    return history.push('/')
  }    
  };
  return <>{_renderBody()}</>;
};
